<template>
  <div class="swipeContainerWrap">
    <img @click="onHide" class="icon_close" src="static/images/icon_close.png" alt="">
    <van-swipe class="my-swipe" indicator-color="#b0b0b0">
      <van-swipe-item v-for="(record, index) in dataList" :key="index">
        <div class="title"> <span class="line"></span> {{ record.title }}</div>
        <div class="image_box" v-if="record.cover"> <img :src='record.cover' alt=""> </div>
        <!-- article type -->
        <div class="sectionWrap" v-if="record.text.length">
          <div class="section" v-for="(item, index) in record.text" :key="index">
            <p class="paragraph">{{ item.content }}</p>
            <span class="desc">{{ item.desc }}</span>
          </div>
        </div>
        <!-- list type -->
        <div class="listWrap" v-if="record.list.length">
          <div class="section" v-for="(item, index) in record.list" :key="index">
            <div></div>
            <div class="title">{{ item.title }}</div>
            <div class="content">
              <div class="intro">
                <span class="dot" v-if="item.dot"></span>
                {{ item.intro }}
              </div>
              <div class="cover"> <img :src='item.cover' alt=""> </div>
            </div>
          </div>
        </div>
      </van-swipe-item>
    </van-swipe>
  </div>
</template>

<script>
export default {
  name: 'SwipeContainer',
  props: {
    dataList: {
      type: Array,
      default: () => []
    }
  },
  methods: {
    onHide () {
      this.$emit('hideSwipe')
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang='less'>
  .van-swipe__track {
    height: 1134px;
  }
  .van-swipe__indicator {
    width: 22px;
    height: 22px;
    background-color: #fff;
  }
  .van-swipe__indicator--active {
    background-color: #e10010 !important;
  }
</style>
<style lang='less' scoped>
.swipeContainerWrap {
  position: relative;
  border-bottom-right-radius: 50px;

  .icon_close {
    width: 47px;
    height: 47px;
    position: absolute;
    right: 0;
    top: -60px;
  }

  .my-swipe {
    width: 650px;
    height: 1180px;
  }

  .my-swipe .van-swipe-item {
    background-image: linear-gradient(to top, #ebebeb, #fff);
    border-bottom-right-radius: 50px;

    .title {
      font-size: 32px;
      padding: 30px;
      color: #202020;
      display: flex;
      align-items: center;

      .line {
        display: inline-block;
        width: 6px;
        height: 34px;
        background-color: #e10010;
        margin-right: 10px;
      }
    }

    .image_box {
      width: 100%;
      height: 428px;
      img {
        width: 100%;
        display: block;
      }
    }
    .sectionWrap {
      padding: 0 50px;
    }
    .section {
      .paragraph {
        font-size: 24px;
        color: #202020;
        line-height: 2;
        -webkit-font-smoothing: antialiased;
      }
      .desc {
        font-size: 24px;
      }
    }
    .listWrap {
      padding: 0 50px;
      .section {
        border-top: 2px solid #d3d3d3;
        margin-top: 30px;
        padding-top: 30px;
        .title {
          color: #202020;
          font-size: 26px;
          font-weight: 500;
          padding: 0;
        }
        .content {
          display: flex;
          .intro {
            color: #202020;
            font-size: 24px;
            flex: 1;
            line-height: 38px;
            position: relative;

            .dot {
              position: absolute;
              width: 10px;
              height: 10px;
              top: 12px;
              left: -15px;
              border-radius: 50%;
              background-color: #e10010;
            }
          }
          .cover {
            width: 184px;
            height: 140px;
            margin-left: 40px;
            img {
              display: block;
              width: 100%;
            }
          }
        }
      }
    }
  }
}
</style>
